import { showPivotEnableDisableDialog } from '../actions/publicActions';
import { mutator } from 'satcheljs';
import store from '../store/Store';
import getInboxPlusPivots from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivots';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';

mutator(showPivotEnableDisableDialog, actionMessage => {
    // deep copy current pivots from user configuration
    store.enabledDisabledPivots = getInboxPlusPivots().map((pivot: InboxPlusPivotViewState) => ({
        ...pivot,
    }));
});
